// extracted by css-extract-rspack-plugin
export default {"pageSettingsContainer":"src-wab-client-components-PageSettings-module__pageSettingsContainer-HlPoss"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageSettingsContainer\":\"src-wab-client-components-PageSettings-module__pageSettingsContainer-HlPoss\"}";
        // 1793541990485
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  